import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AuthStore } from '@smata-login-page';
import { SmataHeaderPageComponent, SmataNavbarComponent } from '@smata-shared';
import { PageHeaderStoreService } from '@smata-shell';
import { distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';
import { DEFAULT_PAGE_TITLE } from './main-layout.constants';

@Component({
  selector: 'smata-main-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, SmataNavbarComponent, SmataHeaderPageComponent],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class SmataMainLayoutComponent implements OnInit {
  readonly pageHeaderStore = inject(PageHeaderStoreService);
  private readonly authStore = inject(AuthStore);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map((event) => event.urlAfterRedirects.split('?')[0]),
        startWith(this.router.url.split('?')[0]),
        distinctUntilChanged(),
        map(() => this.getCurrentRouteTitle()),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((title) => this.pageHeaderStore.setTitle(title));
  }

  public handleUserLogout(): void {
    this.authStore.logout();
  }

  private getCurrentRouteTitle(): string {
    let route = this.activatedRoute;

    while (route.firstChild) {
      route = route.firstChild;
    }

    return route.snapshot.data['title'] ?? DEFAULT_PAGE_TITLE;
  }
}
